export default "__VITE_ASSET__jqgnXUZc__"